import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   redirect: "/IndexMap",
  // },
  // {
  //   path: '/IndexMap',
  //   name: 'IndexMap',
  //   component: () => import('../views/IndexMap.vue'),
  //   meta: {
  //     title: "智慧导览",
  //     // keepAlive: true // 需要被缓存
  //   }
  // },
  {
    path: '/UserAgreement',
    name: 'UserAgreement',
    component: () => import('../views/UserAgreement.vue'),
    meta: {
      title: "用户协议"
    }
  },
  {
    path: '/PrivacyAgreement',
    name: 'PrivacyAgreement',
    component: () => import('../views/PrivacyAgreement.vue'),
    meta: {
      title: "隐私协议"
    }
  },
  {
    path: '/VIPAgreement',
    name: 'VIPAgreement',
    component: () => import('../views/VIPAgreement.vue'),
    meta: {
      title: "VIP服务协议"
    }
  },
  {
    path: '/BusinessCooperation',
    name: 'BusinessCooperation',
    component: () => import('../views/BusinessCooperation.vue'),
    meta: {
      title: "商务合作"
    }
  },

  {
    path: '/Help',
    name: 'Help',
    component: () => import('../views/Help.vue'),
    meta: {
      title: "帮助"
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
